import React from "react";
import { safeToLowerCase } from "../../../../shared-functions/string";
import ResourceIcon from "../../../../components/shared/grid-bits/resources/ResourceIcon";
import { OpenStackResourceOrOther } from "../../../types";

type NetworkStatusProps = {
  resource: OpenStackResourceOrOther;
  isSharedNetwork: boolean;
};

/**
 * Determine the correct status string for a given network resource.
 *
 * Priority order:
 *   1. If it’s a shared network → “error”
 *   2. If it’s an external router network → “active - external network”
 *   3. If `task_state` is set → lowercase(task_state)
 *   4. If `status` is set → lowercase(status)
 *   5. Fallback → “active”
 */
function getNetworkStatus(
  resource: OpenStackResourceOrOther,
  isSharedNetwork: boolean,
): string {
  if (isSharedNetwork) {
    return "error";
  }
  if (resource["router:external"]) {
    return "active - external network";
  }
  if (resource.task_state) {
    return safeToLowerCase(resource.task_state);
  }
  if (resource.status) {
    return safeToLowerCase(resource.status);
  }
  return "active";
}
export const NetworkStatus: React.FC<NetworkStatusProps> = ({
  resource,
  isSharedNetwork,
}) => {
  const statusString = getNetworkStatus(resource, isSharedNetwork);
  return <ResourceIcon status={statusString} popup={!isSharedNetwork} />;
};

export default NetworkStatus;
